import { SearchInput } from '../shared';
import { SortOrder, OfficeEquipmentBrandSortType } from '../enums';

export class GetOfficeEquipmentBrandsInput extends SearchInput<OfficeEquipmentBrandSortType> {
    constructor() {
        super(OfficeEquipmentBrandSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}
